var React = require('react');

function Round (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M250 501C111.93 501 0 388.847 0 250.5 0 112.153 111.93 0 250 0s250 112.153 250 250.5C500 388.847 388.07 501 250 501z","fill":"#F8F9FA","fillRule":"evenodd","opacity":".675"}));
}

Round.defaultProps = {"width":"500","height":"501"};

module.exports = Round;

Round.default = Round;
